import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

// enforce UTC for all dates
dayjs.extend(utc);

export const getDSLDateForDateValue = (dateValue: string) => {
  const dateValueAsDate = dayjs.utc(dateValue);
  return `${dateValueAsDate.format('YYYY-MM-DD')}`;
};
